module.exports = __webpack_public_path__ + "img/tu-1_02.4243220b.jpg";